"use client";

import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { SignUpForm } from "../forms/sign-up-form";

export function SignUpView() {
  const router = useRouter();

  const handleSuccess = () => {
    toast.success("Conta criada com sucesso!");
    router.push("/onboard");
  };

  const handleError = (error: any) => {
    const errorMessage = Array.isArray(error?.message) ? error.message[0] : error?.message;
    toast.error(errorMessage || "Erro ao criar conta.");
  };

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-md">
        <div className="flex flex-col gap-4">
          <div className="absolute top-8 left-8 opacity-95">
            <Link
              href="/"
              className="flex items-center gap-2 text-sm text-black/70 dark:text-white/70 hover:text-black dark:hover:text-white transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              Volta para início
            </Link>
          </div>

          <SignUpForm onSuccess={handleSuccess} onError={handleError} />
        </div>
      </div>
    </div>
  );
}
